// import { DTO__generation } from '@shared/dto/generation/DTO__generation';
// import { DTOToken } from '@shared/dto/generation/settings/token/dto_token';
// import { logi } from '@shared/utils/utils_logs';
// import { establish_word_object_for_tokens } from '../../../services/translate/_methods/establish_word_object_for_tokens';

import { DTO__generation } from '@shared/dto/generation/DTO__generation';
import { logi } from '@shared/utils/utils_logs';

export function FN_WORDS__init_in_tokens_generation(entities: DTO__generation[]) {
  logi('stablish word object for tokens for fields CONDITIONING');
  // for (let entity of entities) {
  //   entity.settings.tokens = establish_word_object_for_tokens(entity.settings.tokens);

  //   entity.settings.tokens = entity.settings.tokens.sort(DTOToken.sortByWordTranslated);
  // }
}
